import React, { useMemo, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  makeStyles,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { includes, isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import { changeDrawer } from '~/store/modules/drawer/actions';

import { MenuList } from '..';

const useStyles = makeStyles((theme) => ({
  first: { paddingLeft: theme.spacing(8) },
  second: { paddingLeft: theme.spacing(12) },
}));

export default function MenuDropdown({ items }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { first, second } = useSelector((state) => state.drawer);
  const openedFirst = useMemo(() => first === items.key, [first, items]);

  function changedDrawer(key, value) {
    if (includes([first, second], value)) {
      dispatch(changeDrawer(key, null));
    } else {
      dispatch(changeDrawer(key, value));
    }
  }

  return (
    <>
      <ListItem
        button
        onClick={() => changedDrawer('first', items.key)}
        className={items.mobile && 'hiddenMobile'}
      >
        {items.icon && <ListItemIcon>{items.icon}</ListItemIcon>}
        <ListItemText primary={items.title} />
        {window.innerWidth > 768 && (
          <>{openedFirst ? <ExpandLess /> : <ExpandMore />}</>
        )}
      </ListItem>

      <Collapse in={openedFirst} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items.children.map((item) => {
            return isUndefined(item.children) ? (
              <MenuList
                key={item.key}
                url={item.url}
                title={item.title}
                icon={item.icon}
                styled={classes.first}
                hiddenMobile={item.mobile}
              />
            ) : (
              <Fragment key={items.key}>
                <ListItem
                  button
                  onClick={() => changedDrawer('second', item.key)}
                  className={classes.first}
                >
                  {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                  <ListItemText primary={item.title} />
                  {item.key === second ? <ExpandLess /> : <ExpandMore />}
                </ListItem>

                <Collapse in={item.key === second} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.children.map((i) => (
                      <MenuList
                        key={i.key}
                        url={i.url}
                        title={i.title}
                        icon={i.icon}
                        styled={classes.second}
                      />
                    ))}
                  </List>
                </Collapse>
              </Fragment>
            );
          })}
        </List>
      </Collapse>
    </>
  );
}

MenuDropdown.propTypes = {
  items: PropTypes.object,
};

MenuDropdown.defaultProps = {
  items: {},
};
